import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "min-h-screen bg-stone-50 dark:bg-stone-950 text-stone-800 dark:text-stone-200 transition-colors duration-300"
}
const _hoisted_2 = { class: "flex flex-col lg:flex-row min-h-screen" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col px-8 lg:px-12 py-16 lg:py-0 max-w-md animate-fade-in"
}
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center"
}
const _hoisted_5 = { class: "max-w-2xl mx-auto px-6 lg:px-12 py-12 lg:py-16" }

import ProfileHeader from "@/components/ProfileHeader.vue";
import SocialSection from "@/components/SocialSection.vue";
import { usePortfolioStore } from "@/store/portfolioStore";
import { storeToRefs } from "pinia";
import { onMounted, computed } from "vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  setup(__props) {

const portfolioStore = usePortfolioStore();
const { portfolio, loading } = storeToRefs(portfolioStore);
const { loadPortfolio } = portfolioStore;

const portfolioData = portfolio;
const isLoading = loading;
const route = useRoute();

const leftSectionClass = computed(() => {
  return route.name === "project"
    ? "w-full lg:w-[35%] lg:fixed lg:h-screen lg:left-0"
    : "w-full lg:w-1/2 lg:fixed lg:h-screen lg:left-0";
});

const rightSectionClass = computed(() => {
  return route.name === "project"
    ? "w-full lg:w-[65%] lg:ml-[35%] min-h-screen"
    : "w-full lg:w-1/2 lg:ml-[50%] min-h-screen";
});

onMounted(async () => {
  await loadPortfolio();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([leftSectionClass.value, "relative bg-stone-100 dark:bg-stone-900 flex items-center justify-center transition-all duration-500 ease-out"])
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 right-0 hidden lg:block w-px bg-gradient-to-b from-transparent via-brand-500/35 dark:via-brand-300/25 to-transparent" }, null, -1)),
        (!_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(ProfileHeader, {
                introduction: _unref(portfolioData)?.introduction
              }, null, 8, ["introduction"]),
              _createVNode(SocialSection, {
                socials: _unref(portfolioData)?.socials
              }, null, 8, ["socials"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "w-6 h-6 border-2 border-stone-300 dark:border-stone-600 border-t-stone-600 dark:border-t-stone-300 rounded-full animate-spin" }, null, -1)
            ]))]))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([rightSectionClass.value, "overflow-y-auto bg-gradient-to-br from-stone-50 via-stone-100 to-stone-50 dark:from-stone-950 dark:via-stone-900 dark:to-black transition-all duration-500 ease-out"])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_Transition, {
            name: "slide-fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ])
      ], 2)
    ])
  ]))
}
}

})